import { render, staticRenderFns } from "./SocialUploadForm.vue?vue&type=template&id=99f9ac42&scoped=true"
import script from "./SocialUploadForm.vue?vue&type=script&lang=js"
export * from "./SocialUploadForm.vue?vue&type=script&lang=js"
import style0 from "./SocialUploadForm.vue?vue&type=style&index=0&id=99f9ac42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f9ac42",
  null
  
)

export default component.exports